module.exports = __webpack_public_path__ + "img/background.1137c3fd.png";